// LeaderboardManager.js — Global & Local Top 20 Flat-File Leaderboard System (Real Players Only)

export class LeaderboardManager {
  constructor() {
    this.scores = this.loadLocalScores();
    this.lastSubmittedRank = null;
    this.isLoading = false;
    this.fetchScores();
  }

  loadLocalScores() {
    try {
      const saved = localStorage.getItem('bricksYoLeaderboard');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          // Filter out any legacy test/mock default scores if they exist
          const filtered = parsed.filter(item => item && item.name && typeof item.score === 'number' && !item.isMock);
          return filtered;
        }
      }
    } catch {}
    return [];
  }

  saveLocalScores(scores) {
    try {
      localStorage.setItem('bricksYoLeaderboard', JSON.stringify(scores || []));
    } catch {}
  }

  fetchScores() {
    this.isLoading = true;
    fetch('/cgi-bin/leaderboard.pl')
      .then(res => res.json())
      .then(data => {
        if (data && Array.isArray(data.top20)) {
          this.scores = data.top20;
          this.saveLocalScores(this.scores);
        }
      })
      .catch(() => {
        // Fallback to local storage scores
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  submitScore(name, score, sector = 'SECTOR 1') {
    if (!name || score <= 0) return Promise.resolve({ isTop20: false, rank: null });

    const payload = {
      name: name.slice(0, 24),
      score: parseInt(score, 10),
      sector: sector.slice(0, 20),
    };

    // Update local fallback immediately
    const existing = Array.isArray(this.scores) ? [...this.scores] : [];
    
    // Check if player already has an entry and only keep their highest score
    const existingIdx = existing.findIndex(e => e.name === payload.name);
    if (existingIdx >= 0) {
      if (payload.score > existing[existingIdx].score) {
        existing[existingIdx] = { ...payload, rank: 0 };
      }
    } else {
      existing.push({ ...payload, rank: 0 });
    }

    existing.sort((a, b) => b.score - a.score);
    const trimmed = existing.slice(0, 20).map((entry, idx) => ({ ...entry, rank: idx + 1 }));
    this.scores = trimmed;
    this.saveLocalScores(this.scores);

    const playerIndex = trimmed.findIndex(e => e.name === payload.name && e.score === payload.score);
    const localRank = playerIndex >= 0 ? playerIndex + 1 : null;
    if (localRank) this.lastSubmittedRank = localRank;

    // Send to Perl CGI script
    return fetch('/cgi-bin/leaderboard.pl', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        if (data && Array.isArray(data.top20)) {
          this.scores = data.top20;
          this.saveLocalScores(this.scores);
          if (typeof data.rank === 'number') {
            this.lastSubmittedRank = data.rank;
          }
          return { isTop20: data.isTop20, rank: data.rank };
        }
        return { isTop20: !!localRank, rank: localRank };
      })
      .catch(() => {
        return { isTop20: !!localRank, rank: localRank };
      });
  }
}
